import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

const FieldMonitorSidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuGroups = [
    {
      title: 'FIELD OPERATIONS',
      items: [
        { id: 'incident-scan', icon: 'ion:scan-outline', label: 'Incident Scan' },
        { id: 'running-queue', icon: 'ion:list-outline', label: 'Running Queue' },
        { id: 'history', icon: 'ion:time-outline', label: 'Incident History' },
      ]
    },
    {
      title: 'USER SETTINGS',
      items: [
        { id: 'profile', icon: 'ion:person-circle-outline', label: 'My Profile' },
      ]
    }
  ];

  return (
    <aside className={`fm-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button 
        className="fm-sidebar-toggle" 
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <Icon icon={isCollapsed ? "ion:chevron-forward" : "ion:chevron-back"} width="16" />
      </button>

      {/* Brand Header */}
      <div className="fm-sidebar-brand">
        <div className="fm-brand-icon-box">
          <Icon icon="ion:shield-checkmark" width="24" />
        </div>
        {!isCollapsed && (
            <motion.div 
                initial={{ opacity: 0, x: -10 }} 
                animate={{ opacity: 1, x: 0 }}
                className="fm-brand-text-box"
            >
                <span className="fm-brand-main">ICFF India</span>
            </motion.div>
        )}
      </div>

      <nav className="fm-sidebar-nav hide-scrollbar">
        {menuGroups.map((group, groupIdx) => (
          <div key={groupIdx} className="fm-nav-group">
            {!isCollapsed && (
              <div className="fm-nav-group-title">
                {group.title}
              </div>
            )}
            {group.items.map((item) => {
              const isActive = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  className={`fm-nav-item ${isActive ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.id)}
                >
                  {isActive && (
                    <>
                      <motion.div
                        layoutId="fmSidebarActivePill"
                        className="fm-nav-active-pill"
                        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                      />
                      <motion.div 
                        layoutId="fmActiveIndicator"
                        className="fm-nav-active-indicator"
                      />
                    </>
                  )}
                  
                  <div className="fm-nav-content">
                    <Icon
                      icon={item.icon}
                      width="22"
                      className="fm-nav-icon"
                    />
                    {!isCollapsed && (
                      <span className="fm-nav-label">
                        {item.label}
                      </span>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="fm-sidebar-footer" style={{ padding: '20px' }}>
        <button
          onClick={onLogout}
          className="universal-logout-btn"
        >
          <Icon icon="ion:log-out-outline" width="22" />
          {!isCollapsed && <span style={{ fontWeight: 700 }}>Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default FieldMonitorSidebar;
